import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconTextLite = createSVG({
    width: 48,
    children: (jsx("path", { d: "M11.588 6v9.737h4.578V18H9.223V6zm8.288 12h-2.367V6h2.366zM30.034 6v2.263h-3.24V18h-2.367V8.263h-3.221V6zm8.656 2.263h-4.97v2.554h4.542v2.229H33.72v2.691h5.058V18h-7.423V6h7.337z" })),
});

export { IconTextLite };
